/* Gravur-MAX (Webstra 10/2026): Korrekturen an den Gravur-Positionen der Foto-Vorschau.
   Läuft nach den Vermessungsdaten und vor dem Aufbau der Vorschau (gm-layout-v2.js startet erst nach DOMContentLoaded).
   Die Vermessungsdateien selbst bleiben unverändert (sie werden auch vom Live-Theme genutzt). */
(function(){
  if(window.__wbLayFix)return;window.__wbLayFix=1;
  /* Namensglas mit Initialen (Puccini): Der Buchstabe sitzt groß über dem Namen.
     Die Vermessung hatte ihn auf das "M" von "Michael" gelegt, dadurch blieb das "M" aus dem Produktfoto stehen
     und der eingegebene Buchstabe erschien in der Namenszeile. Werte aus dem Produktfoto gemessen (Anteil der Bildbreite). */
  function initialen(L,N){
    if(!L||!N)return;
    L[2]=N[2];            /* waagerecht mittig zum Namen */
    L[3]=0.253;           /* Mitte des Buchstabens (Foto: 0,189 bis 0,317) */
    L[4]=0.15;            /* Breite des Buchstabens */
    if(L[8])for(var k in L[8])L[8][k]=[1,0.17];
    L[9]=[N[2]-0.11,0.175,N[2]+0.11,0.318]; /* Bereich, in dem der Buchstabe aus dem Foto ausgeblendet wird */
    L[11]=[0.178,0.322,1];                  /* erlaubte Höhe */
  }
  function apply(){
    var f=(window.GM_LAY||{})['gm-preview-puccini'];
    if(!f||!f.m)return;
    var one=f.m['1g']&&f.m['1g']['namensglas-mit-initialen-mit-wunschname'];
    if(one&&one.sl){
      var l=one.sl.filter(function(s){return s[0]==='{letter}';})[0],n=one.sl.filter(function(s){return s[0]==='{name}';})[0];
      initialen(l,n);
    }
    var two=f.m['2g']&&f.m['2g']['namensglas-mit-initialen-2-glaeser-mit-wunschname'];
    if(two&&two.sl){
      ['1','2'].forEach(function(g){
        var l=two.sl.filter(function(s){return s[0]==='{letter@'+g+'}';})[0],n=two.sl.filter(function(s){return s[0]==='{name@'+g+'}';})[0];
        initialen(l,n);
      });
    }
  }
  apply();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply);
})();
